import lastJurisdictionVisitedSubscription from "./lastJurisdictionVisitedSubscription"
import setLoggedUserSubscription from "./setLoggedUserSubscription"
import allAssumptionsMutationChanges from "./allAssumptionsMutationChanges"

export default (Store) => {
  lastJurisdictionVisitedSubscription(Store)
  setLoggedUserSubscription(Store)
  allAssumptionsMutationChanges(Store)
}